/*
  Shopify Wishlist
  v2.3.2

  Behåller befintligt filnamn: assets/Wishlist.js

  App Proxy:
  - Shopify proxy: /apps/wubs-recipes
  - Proxy URL: https://knatteplock-recept.lovable.app/api/public
  - Wishlist base: /apps/wubs-recipes/wishlist

  Fokus:
  - Vanliga klick använder POST /set med active true/false
  - Inga automatiska migrate/sync-anrop på sidladdning
  - Inloggad kund hämtar wishlist via GET, men account page kan seeda cache från Liquid-renderade kort
  - Klick uppdaterar hjärtat direkt, sedan POST /set
  - Backend är source of truth för sparning
  - LocalStorage används som snabb cache + gästwishlist
  - Skickar recipe_ref + has_recipe_ref när button-wishlist har receptmetafält
*/

(function () {
  console.log('[Wishlist.js] NEW FILE LOADED v2.3.2', new Date().toISOString());

  const API_BASE_DEFAULT = '/apps/wubs-recipes/wishlist';

  const GUEST_STORAGE_KEY = 'wishlist';
  const CACHE_STORAGE_KEY = 'shopify-wishlist-items';
  const LEGACY_STORAGE_KEY = 'shopify-wishlist';

  const BUTTON_SELECTOR = '[button-wishlist]';
  const ACTIVE_CLASS = 'active';

  let wishlistCache = [];
  let clickBound = false;
  let helpersBound = false;
  let readyPromise = null;

  function getConfigValue(key, fallback) {
    if (window.ShopifyWishlistConfig && window.ShopifyWishlistConfig[key] !== undefined) {
      return window.ShopifyWishlistConfig[key];
    }

    return fallback;
  }

  function normalizeApiBase(value) {
    const cleanValue = String(value || API_BASE_DEFAULT).trim();
    return cleanValue.replace(/\/$/, '');
  }

  function getApiBase() {
    const root = document.querySelector('[data-wishlist-root]');
    const domBase = root ? root.getAttribute('data-wishlist-api-base') : '';

    const configuredBase = normalizeApiBase(
      getConfigValue('apiBase', '') ||
      window.ShopifyWishlistApiBase ||
      domBase ||
      API_BASE_DEFAULT
    );

    if (
      configuredBase === '/api/public/wishlist' ||
      configuredBase === '/apps/recept/wishlist' ||
      configuredBase.includes('/apps/recept')
    ) {
      return API_BASE_DEFAULT;
    }

    return configuredBase;
  }

  function getEndpoint(path) {
    return getApiBase() + (path || '');
  }

  function getShopDomain() {
    const root = document.querySelector('[data-wishlist-root]');
    const domShop = root ? root.getAttribute('data-shop-domain') || root.getAttribute('data-shop') : '';

    return (
      getConfigValue('shopDomain', '') ||
      window.ShopifyWishlistShopDomain ||
      domShop ||
      window.Shopify?.shop ||
      document.querySelector('[data-shop]:not([data-shop=""])')?.getAttribute('data-shop') ||
      document.querySelector('[data-shop-domain]:not([data-shop-domain=""])')?.getAttribute('data-shop-domain') ||
      ''
    );
  }

  function getCustomerId() {
    const root = document.querySelector('[data-wishlist-root]');
    const domCustomer = root ? root.getAttribute('data-customer-id') || root.getAttribute('data-customer') : '';

    return (
      getConfigValue('customerId', '') ||
      window.ShopifyWishlistCustomerId ||
      domCustomer ||
      document.querySelector('[data-customer]:not([data-customer=""])')?.getAttribute('data-customer') ||
      document.querySelector('[data-customer-id]:not([data-customer-id=""])')?.getAttribute('data-customer-id') ||
      document.getElementById('CustomerLoginForm')?.getAttribute('data-cid') ||
      ''
    );
  }

  function getLocale() {
    return (
      getConfigValue('locale', '') ||
      window.Shopify?.locale ||
      document.documentElement.lang ||
      'sv'
    );
  }

  function normalizeUrl(url) {
    if (!url) return '';

    const cleanUrl = String(url);

    if (cleanUrl.startsWith('//')) {
      return window.location.protocol + cleanUrl;
    }

    return cleanUrl;
  }

  function parseTags(value) {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }

    return String(value)
      .split('||')
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  function normalizeBoolean(value) {
    return value === true || value === 'true' || value === '1' || value === 1;
  }

  function normalizeType(type, url) {
    const cleanType = String(type || '').toLowerCase();
    const cleanUrl = String(url || '');

    if (cleanType === 'product') return 'product';
    if (cleanType === 'recipe') return 'recipe';
    if (cleanType === 'blog') return 'blog';
    if (cleanType === 'article') return 'blog';

    if (cleanUrl.includes('/blogs/enkla-recept-for-barn-familj/') ||
    cleanUrl.includes('/blogs/oppskrifter-for-hele-familien-fra-6-maneder')) {
  return 'recipe';
}


    if (cleanUrl.includes('/blogs/')) {
      return 'blog';
    }

    return 'product';
  }

  function normalizeItem(item) {
    if (!item) return null;

    const shopifyId =
      item.shopify_id ||
      item.shopifyId ||
      item.wishlist_id ||
      item.wishlistId ||
      item.id ||
      '';

    if (!shopifyId) return null;

    const url = normalizeUrl(item.url || item.href || '');
    const recipeRef = item.recipe_ref || item.recipeRef || '';
    const hasRecipeRef =
      normalizeBoolean(item.has_recipe_ref) ||
      normalizeBoolean(item.hasRecipeRef) ||
      Boolean(recipeRef);

    const itemType = hasRecipeRef
      ? 'recipe'
      : normalizeType(item.item_type || item.type || item.wishlist_type || item.t, url);

    return {
      shop_domain: item.shop_domain || item.shop || getShopDomain(),
      customer_id: item.customer_id || item.customer || getCustomerId(),
      item_type: itemType,
      shopify_id: String(shopifyId),
      handle: item.handle || '',
      title: item.title || '',
      image_url: normalizeUrl(item.image_url || item.image || ''),
      url: url,
      tags: parseTags(item.tags),
      locale: item.locale || getLocale(),
      recipe_ref: recipeRef,
      has_recipe_ref: hasRecipeRef
    };
  }

  function getItemKey(item) {
    const normalizedItem = normalizeItem(item);

    if (!normalizedItem) return '';

    return normalizedItem.item_type + ':' + normalizedItem.shopify_id;
  }

  function dedupeItems(items) {
    const map = new Map();

    (items || []).forEach(function (item) {
      const normalizedItem = normalizeItem(item);
      const key = getItemKey(normalizedItem);

      if (!key) return;

      map.set(key, {
        ...(map.get(key) || {}),
        ...normalizedItem
      });
    });

    return Array.from(map.values());
  }

  function hasItem(items, item) {
    const key = getItemKey(item);

    return dedupeItems(items).some(function (wishlistItem) {
      return getItemKey(wishlistItem) === key;
    });
  }

  function readJsonStorage(key) {
    try {
      const raw = localStorage.getItem(key);

      if (!raw) return [];

      const parsed = JSON.parse(raw);

      if (!Array.isArray(parsed)) return [];

      return parsed;
    } catch (error) {
      return [];
    }
  }

  function writeJsonStorage(key, items) {
    const normalizedItems = dedupeItems(items);

    if (normalizedItems.length) {
      localStorage.setItem(key, JSON.stringify(normalizedItems));
    } else {
      localStorage.removeItem(key);
    }

    return normalizedItems;
  }

  function readCacheItems() {
    return dedupeItems(readJsonStorage(CACHE_STORAGE_KEY));
  }

  function writeCacheItems(items) {
    const normalizedItems = writeJsonStorage(CACHE_STORAGE_KEY, items);

    if (normalizedItems.length) {
      localStorage.setItem(
        LEGACY_STORAGE_KEY,
        normalizedItems
          .map(function (item) {
            return item.shopify_id;
          })
          .filter(Boolean)
          .join(',')
      );
    } else {
      localStorage.removeItem(LEGACY_STORAGE_KEY);
    }

    wishlistCache = normalizedItems;

    return normalizedItems;
  }

  function clearGuestStorage() {
    localStorage.removeItem(GUEST_STORAGE_KEY);
  }

  function readGuestItems() {
    return dedupeItems(readJsonStorage(GUEST_STORAGE_KEY));
  }

  function writeGuestItems(items) {
    const normalizedItems = writeJsonStorage(GUEST_STORAGE_KEY, items);

    wishlistCache = normalizedItems;

    return normalizedItems;
  }

  function itemFromButton(button) {
    if (!button) return null;

    const shopifyId =
      button.getAttribute('data-id') ||
      button.getAttribute('data-wishlist-id') ||
      button.getAttribute('data-product-handle') ||
      '';

    if (!shopifyId) return null;

    return normalizeItem({
      shop_domain:
        button.getAttribute('data-shop-domain') ||
        button.getAttribute('data-shop') ||
        getShopDomain(),
      customer_id:
        button.getAttribute('data-customer-id') ||
        button.getAttribute('data-customer') ||
        getCustomerId(),
      shopify_id: shopifyId,
      item_type:
        button.getAttribute('data-type') ||
        button.getAttribute('data-wishlist-type') ||
        '',
      handle:
        button.getAttribute('data-handle') ||
        button.getAttribute('data-wishlist-handle') ||
        '',
      title:
        button.getAttribute('data-title') ||
        button.getAttribute('data-wishlist-title') ||
        '',
      image_url:
        button.getAttribute('data-image') ||
        button.getAttribute('data-wishlist-image') ||
        '',
      url:
        button.getAttribute('data-url') ||
        button.getAttribute('data-wishlist-url') ||
        '',
      tags:
        button.getAttribute('data-tags') ||
        button.getAttribute('data-wishlist-tags') ||
        '',
      locale:
        button.getAttribute('data-locale') ||
        button.getAttribute('data-wishlist-locale') ||
        getLocale(),
      recipe_ref:
        button.getAttribute('data-recipe-ref') ||
        button.getAttribute('data-wishlist-recipe-ref') ||
        '',
      has_recipe_ref:
        button.getAttribute('data-has-recipe-ref') === 'true' ||
        button.getAttribute('data-wishlist-has-recipe-ref') === 'true'
    });
  }

  async function requestJson(url, options) {
    const response = await fetch(url, {
      ...(options || {}),
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {})
      }
    });

    let data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    console.log('[wishlist]', options?.method || 'GET', url, response.status, data);

    if (!response.ok) {
      const error = new Error('Wishlist request failed with status ' + response.status);
      error.response = data;
      error.status = response.status;
      throw error;
    }

    return data || {};
  }

  async function fetchServerWishlist() {
    const customerId = getCustomerId();
    const shopDomain = getShopDomain();

    if (!customerId || !shopDomain) {
      return readGuestItems();
    }

    const url =
      getEndpoint('') +
      '?customer_id=' +
      encodeURIComponent(customerId) +
      '&shop=' +
      encodeURIComponent(shopDomain) +
      '&shop_domain=' +
      encodeURIComponent(shopDomain);

    try {
      const data = await requestJson(url, {
        method: 'GET'
      });

      const items = dedupeItems(data.items || []);

      if (items.length) {
        writeCacheItems(items);
      }

      clearGuestStorage();

      return items;
    } catch (error) {
      console.error('[Shopify Wishlist] Could not fetch server wishlist:', error);

      return readCacheItems();
    }
  }

  async function getWishlist(options) {
    const force = options && options.force === true;

    if (!force && wishlistCache && wishlistCache.length) {
      return wishlistCache;
    }

    const customerId = getCustomerId();

    if (!customerId) {
      wishlistCache = readGuestItems();
      refreshButtons(wishlistCache);
      return wishlistCache;
    }

    const cachedItems = readCacheItems();

    if (cachedItems.length) {
      wishlistCache = cachedItems;
      refreshButtons(cachedItems);
    }

    const serverItems = await fetchServerWishlist();

    if (serverItems.length) {
      wishlistCache = serverItems;
      refreshButtons(serverItems);
      return serverItems;
    }

    refreshButtons(wishlistCache);

    return wishlistCache;
  }

  function setLocalItemState(item, active) {
    const currentItems = dedupeItems(wishlistCache.length ? wishlistCache : readCacheItems());
    const key = getItemKey(item);

    const nextItems = active
      ? dedupeItems([...currentItems, item])
      : currentItems.filter(function (wishlistItem) {
          return getItemKey(wishlistItem) !== key;
        });

    wishlistCache = nextItems;

    if (getCustomerId()) {
      writeCacheItems(nextItems);
    } else {
      writeGuestItems(nextItems);
    }

    refreshButtons(nextItems);
    dispatchUpdated(nextItems);

    return nextItems;
  }

  function getNextActiveState(item) {
    const currentItems = dedupeItems(wishlistCache.length ? wishlistCache : readCacheItems());

    return !hasItem(currentItems, item);
  }

  async function setWishlistItem(item, active) {
    const normalizedItem = normalizeItem(item);

    if (!normalizedItem) {
      return getWishlist();
    }

    const customerId = getCustomerId();
    const shopDomain = getShopDomain();
    const beforeItems = dedupeItems(wishlistCache.length ? wishlistCache : readCacheItems());

    setLocalItemState(normalizedItem, active);

    if (!customerId) {
      console.log('[wishlist] guest localStorage updated', wishlistCache);
      return wishlistCache;
    }

    try {
      const payload = {
        shop_domain: shopDomain || normalizedItem.shop_domain,
        shop: shopDomain || normalizedItem.shop_domain,
        customer_id: customerId,
        item_type: normalizedItem.item_type,
        shopify_id: normalizedItem.shopify_id,
        handle: normalizedItem.handle,
        title: normalizedItem.title,
        image_url: normalizedItem.image_url,
        url: normalizedItem.url,
        tags: normalizedItem.tags,
        locale: normalizedItem.locale,
        recipe_ref: normalizedItem.recipe_ref || '',
        has_recipe_ref: normalizedItem.has_recipe_ref === true,
        active: active === true
      };

      console.log('[wishlist] sending set', payload);

      const data = await requestJson(getEndpoint('/set'), {
        method: 'POST',
        keepalive: true,
        body: JSON.stringify(payload)
      });

      if (Array.isArray(data.items)) {
        const serverItems = dedupeItems(data.items);

        writeCacheItems(serverItems);
        clearGuestStorage();

        refreshButtons(serverItems);
        dispatchUpdated(serverItems);

        return serverItems;
      }

      refreshButtons(wishlistCache);
      dispatchUpdated(wishlistCache);

      return wishlistCache;
    } catch (error) {
      console.error('[Shopify Wishlist] Could not set server wishlist item:', error);

      writeCacheItems(beforeItems);
      refreshButtons(beforeItems);
      dispatchUpdated(beforeItems);

      return beforeItems;
    }
  }

  async function toggleWishlistItem(item) {
    const normalizedItem = normalizeItem(item);

    if (!normalizedItem) {
      return getWishlist();
    }

    const nextActive = getNextActiveState(normalizedItem);

    return setWishlistItem(normalizedItem, nextActive);
  }

  async function clearWishlist() {
    const customerId = getCustomerId();
    const shopDomain = getShopDomain();

    wishlistCache = [];
    writeCacheItems([]);
    writeGuestItems([]);
    refreshButtons([]);
    dispatchUpdated([]);

    if (customerId && shopDomain) {
      try {
        await requestJson(
          getEndpoint('') +
            '?customer_id=' +
            encodeURIComponent(customerId) +
            '&shop=' +
            encodeURIComponent(shopDomain) +
            '&shop_domain=' +
            encodeURIComponent(shopDomain),
          {
            method: 'DELETE'
          }
        );
      } catch (error) {
        console.error('[Shopify Wishlist] Could not clear server wishlist:', error);
      }
    }

    return [];
  }

  function refreshButtons(items) {
    const wishlistItems = dedupeItems(items || wishlistCache || []);
    const activeKeys = new Set(wishlistItems.map(getItemKey));

    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      const item = itemFromButton(button);

      if (!item) return;

      const isActive = activeKeys.has(getItemKey(item));

      button.classList.toggle(ACTIVE_CLASS, isActive);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  async function refreshWishlistButtons() {
    const items = await getWishlist({
      force: true
    });

    refreshButtons(items);

    document.dispatchEvent(
      new CustomEvent('shopify-wishlist:init-buttons', {
        detail: {
          wishlist: items,
          items: items
        }
      })
    );

    return items;
  }

  function dispatchUpdated(items) {
    document.dispatchEvent(
      new CustomEvent('shopify-wishlist:updated', {
        detail: {
          wishlist: items,
          items: items
        }
      })
    );
  }

  function bindWishlistClicks() {
    if (clickBound) return;

    clickBound = true;

    document.addEventListener(
      'click',
      async function (event) {
        const button = event.target.closest(BUTTON_SELECTOR);

        if (!button) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const item = itemFromButton(button);

        if (!item) {
          console.error('[Shopify Wishlist] Missing wishlist data on button.');
          return;
        }

        button.classList.add('is-loading');

        try {
          await toggleWishlistItem(item);
        } finally {
          button.classList.remove('is-loading');
        }
      },
      true
    );

    console.log('[wishlist] click listener bound in capture mode');
  }

  function closeLoginPopup() {
    const loginPopup = document.getElementById('loginPopup');

    if (!loginPopup) return;

    loginPopup.style.display = 'none';
    loginPopup.classList.remove('show');
  }

  function bindOldLoginPopupHelpers() {
    if (helpersBound) return;

    helpersBound = true;

    document.addEventListener('click', function (event) {
      const loginPopup = document.getElementById('loginPopup');
      const targetElement = event.target;

      if (
        loginPopup &&
        !loginPopup.contains(targetElement) &&
        !targetElement.closest('._wishlistIcon') &&
        !targetElement.closest('._notCutomerpp')
      ) {
        closeLoginPopup();
      }
    });

    document.querySelectorAll('._notCutomerpp').forEach(function (loginButton) {
      loginButton.addEventListener('click', function (event) {
        event.preventDefault();

        const loginPopup = document.getElementById('loginPopup');

        if (loginPopup) {
          loginPopup.style.display = 'block';
          loginPopup.classList.add('show');
        }
      });
    });

    const passwordInput = document.getElementById('CustomerPassword');
    const passwordShowButton = document.getElementById('CustomerPasswordShow');

    if (passwordInput && passwordShowButton) {
      passwordShowButton.addEventListener('click', function () {
        passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
      });
    }
  }

  function bootWishlist() {
    if (readyPromise) return readyPromise;

    console.log('[wishlist] booting', {
      readyState: document.readyState,
      apiBase: getApiBase(),
      customerId: getCustomerId(),
      shopDomain: getShopDomain()
    });

    bindWishlistClicks();
    bindOldLoginPopupHelpers();

    const cachedItems = getCustomerId() ? readCacheItems() : readGuestItems();

    if (cachedItems.length) {
      wishlistCache = cachedItems;
      refreshButtons(cachedItems);
    }

    readyPromise = getWishlist({
      force: true
    }).then(function (items) {
      refreshButtons(items);

      document.dispatchEvent(
        new CustomEvent('shopify-wishlist:ready', {
          detail: {
            wishlist: items,
            items: items
          }
        })
      );

      console.log('[wishlist] ready', items);

      return items;
    });

    return readyPromise;
  }

  async function syncWishlist(items) {
    const customerId = getCustomerId();
    const shopDomain = getShopDomain();
    const normalizedItems = dedupeItems(items);

    if (!customerId || !shopDomain) {
      return normalizedItems;
    }

    try {
      const data = await requestJson(getEndpoint('/sync'), {
        method: 'POST',
        keepalive: true,
        body: JSON.stringify({
          shop_domain: shopDomain,
          shop: shopDomain,
          customer_id: customerId,
          items: normalizedItems
        })
      });

      const serverItems = dedupeItems(data.items || normalizedItems);

      writeCacheItems(serverItems);
      clearGuestStorage();
      refreshButtons(serverItems);
      dispatchUpdated(serverItems);

      return serverItems;
    } catch (error) {
      console.error('[Shopify Wishlist] Could not sync server wishlist:', error);
      return normalizedItems;
    }
  }

  async function migrateLegacyWishlist() {
    console.warn('[Shopify Wishlist] migrateLegacyWishlist is disabled on storefront load. Use backend/manual migration if needed.');
    return getWishlist({
      force: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWishlist);
  } else {
    bootWishlist();
  }

  document.addEventListener('shopify:section:load', function () {
    refreshWishlistButtons();
  });

  window.ShopifyWishlist = {
    getWishlist: getWishlist,
    syncWishlist: syncWishlist,
    setWishlistItem: setWishlistItem,
    toggleWishlistItem: toggleWishlistItem,
    refreshWishlistButtons: refreshWishlistButtons,
    clearWishlist: clearWishlist,
    readLocalItems: readCacheItems,
    writeLocalItems: writeCacheItems,
    migrateLegacyWishlist: migrateLegacyWishlist,
    itemFromButton: itemFromButton
  };
})();